import React from 'react';
import TypeAnimation from 'react-type-animation';
import wood from '../../../images/wood-cutter.jpg'
const BusinessSummery = () => {
    return (
        <div className='my-20'>

            <div className='mx-5 '>
                <div className='grid grid-cols-1 lg:grid-cols-2 md:grid-cols-2'>
                    <div className='flex justify-center items-center'>
                        <img src={wood} className='' alt="" />
                    </div>
                    <div className='mt-5'>
                        <div className=''>
                            <h1 data-aos="flip-down" className='text-black text-5xl font-bold banner_text leading-relaxed'>CHOOSE THE BEST ITEMS <br />FROM OUR COLLECTION
                            </h1>
                            {/* <TypeAnimation className='text-black text-5xl font-bold banner_text leading-relaxed'
                                cursor={false}
                                sequence={['CHOOSE THE BEST ITEMS FROM OUR COLLECTION', 1000, '']}
                                wrapper="h2"
                            /> */}


                            <p className='my-5 text-lg banner_text text-gray-600 leading-10'>Lorem ipsum, dolor sit amet consectetur adipisicing elit.  <br /> exercitationem sapiente ame</p>

                            <h2 className='text-xl banner_text font-semibold'><span className='text-gray-400'>1. </span> FUNCTIONAL DESIGN</h2>
                            <h2 className='text-xl banner_text font-semibold mt-5'><span className='text-gray-400 '>2. </span>  INDIVIDUAL STYLE</h2>
                            <h2 className='text-xl banner_text font-semibold mt-5'><span className='text-gray-400 '>3. </span>  QUALITY PRODUCTS</h2>
                            <button className='mt-8 btn btn-primary rounded-none text-white'>Learn More  → </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* <section class="bg-white">
                <div class="container px-6 py-10 mx-auto">
                    <h1 class="text-3xl font-semibold text-primary capitalize lg:text-5xl dark:text-white text-center banner_text">Millions bussiness trust us <br /> </h1>
                    <h1 class="text-xl font-semibold text-gray-500 capitalize lg:text-xl dark:text-white text-center my-4">Try to understand users Expectations <br /> </h1>



                    <div class="mt-8 xl:mt-12 lg:flex lg:items-center">
                        <div data-aos="fade-right" class="w-full lg:w-1/2 grid grid-cols-1 gap-8 xl:gap-16 md:grid-cols-2">
                            <div class="space-y-4 bg-blue-100 p-4 rounded-3xl">
                                <div className='flex justify-center'>
                                    <span class="inline-block p-5 text-6xl text-blue-500 bg-blue-300 rounded-xl dark:text-white  ">
                                        <FontAwesomeIcon icon={faFlag} />
                                    </span>
                                </div>
                                <div className='flex justify-center'>
                                    <div>
                                        <h1 class="text-5xl font-semibold text-gray-700 capitalize dark:text-white ">79+</h1>

                                        <p class="text-gray-500 dark:text-gray-300 text-center">
                                            Countries
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="space-y-3 bg-blue-100 p-4 rounded-3xl">
                                <div className='flex justify-center'>
                                    <span class="inline-block p-5 text-6xl text-blue-500 bg-blue-300 rounded-xl ">
                                        <FontAwesomeIcon icon={faThumbsUp} />
                                    </span>
                                </div>
                                <div className='flex justify-center'>
                                    <div>
                                        <h1 class="text-5xl font-semibold text-gray-700 capitalize dark:text-white ">654+</h1>

                                        <p class="text-gray-500 dark:text-gray-300 text-center">
                                            Feedbacks
                                        </p>
                                    </div>
                                </div>
                            </div>


                            <div class="space-y-3 bg-blue-100 p-4 rounded-3xl">
                                <div className='flex justify-center'>
                                    <span class="inline-block p-5 text-6xl text-blue-500 bg-blue-300 rounded-xl ">
                                        <FontAwesomeIcon icon={faUsers} />
                                    </span>
                                </div>
                                <div className='flex justify-center'>
                                    <div>
                                        <h1 class="text-5xl font-semibold text-gray-700 capitalize dark:text-white ">743+</h1>

                                        <p class="text-gray-500 dark:text-gray-300 text-center">
                                            Happy Clients
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="space-y-3 bg-blue-100 p-4 rounded-3xl">
                                <div className='flex justify-center'>
                                    <span class="inline-block p-5 text-6xl text-blue-500 bg-blue-300 rounded-xl ">
                                        <FontAwesomeIcon icon={faLaptop} />
                                    </span>
                                </div>
                                <div className='flex justify-center'>
                                    <div>
                                        <h1 class="text-5xl font-semibold text-gray-700 capitalize dark:text-white ">543+</h1>

                                        <p class="text-gray-500 dark:text-gray-300 text-center">
                                            Complete projects
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </section> */}

        </div>
    );
};

export default BusinessSummery;